/* eslint-disable no-undef, strict, no-console, no-unused-vars, no-undefined */
'use strict';

class StoreServiceWorker {
	constructor(options) {
		this.defaults = {
			has_notifications: false
		};
		this.options = Object.assign(this.defaults, options);
		this.registerServiceWorker();
	}

	registerServiceWorker() {
		if ('serviceWorker' in navigator) {
			let _service_worker_name = 'sw';
			if ((this.options.has_notifications || this.options.has_notifications.length) && 'Notification' in window) {
				if (Notification.permission === 'granted' && typeof firebase === 'undefined') {
					_service_worker_name = 'firebase-messaging-sw';
				}
			}

			navigator.serviceWorker.getRegistrations()
				.then(function(registrations) {
					for (let registration of registrations) {
						// unregister other service workers before registering the new one
						// Ex. the old V3 SW, older versions, v4_sw_notifications if the customer removed the notification permission, etc
						if (typeof registration.active !== 'undefined' && registration.active) {
							if (typeof registration.active.scriptURL !== 'undefined' && registration.active.scriptURL) {
								if (registration.active.scriptURL !== s.url(`/${_service_worker_name}.js`, null, true, true)) {
									registration.unregister();
								}
							}
						}
					}
				});

			navigator.serviceWorker.register(s.url(`/${_service_worker_name}.js`, null, false, true)).then(function(registration) {
				console.log('Service worker registration succeeded:', registration);
			}, /*catch*/ function(error) {
				console.log('Service worker registration failed:', error);
			});
		} else {
			console.log('Service workers are not supported.');
		}
	}
}
